/* J-Life 2026 refresh: desktop dropdowns also open on hover (mouse only); click and keyboard work as before. */
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  function setOpen(d, open) {
    var s = d.querySelector('summary');
    if (open) {
      if (!d.hasAttribute('open')) d.setAttribute('open', '');
      if (s) s.setAttribute('aria-expanded', 'true');
    } else {
      if (d.hasAttribute('open')) d.removeAttribute('open');
      if (s) s.setAttribute('aria-expanded', 'false');
      delete d.dataset.jlHover;
    }
  }

  function init() {
    var menus = Array.prototype.slice.call(document.querySelectorAll('.jl-mega-nav details.jl-mega'));
    if (!menus.length) return;

    menus.forEach(function (d) {
      var timer;
      d.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          menus.forEach(function (o) { if (o !== d) setOpen(o, false); });
          if (!d.hasAttribute('open')) {
            d.dataset.jlHover = '1';
            setOpen(d, true);
          }
        }, 90);
      });
      d.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (d.dataset.jlHover === '1') setOpen(d, false);
        }, 180);
      });
      var s = d.querySelector('summary');
      if (s) {
        s.addEventListener('click', function (e) {
          // a mouse user who hovers and then clicks the label keeps the dropdown open
          if (mq.matches && d.dataset.jlHover === '1' && d.hasAttribute('open')) e.preventDefault();
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      menus.forEach(function (o) {
        if (!o.hasAttribute('open')) return;
        var hadFocus = o.contains(document.activeElement);
        setOpen(o, false);
        if (hadFocus) o.querySelector('summary').focus();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
